export const getMannerSignalColor = (score: number) => {
  if (!score) return 'yellow';
  if (score <= 30) return 'red';
  if (score <= 60) return 'yellow';
  return 'green';
};